$(document).ready(function() {
  'use strict';
  var $currencySelect = $('.js-currency-select')
  var elPromoAmount = $('.header--promo-spring');
  if ( $currencySelect.length > 0 ) {
    var $select = $currencySelect.first();

    $currencySelect.change(function(event) {
      var $code = $('.js-currency[data-code="' + $select.val() + '"]');
      if ( $code.length > 0 ) {
        Cookies.set('dc_pricing_currency', $select.val());
        $('.js-currency').hide();
        $('.js-currency[data-code="' + $select.val() + '"]').show();

        if ($select.val() === 'inr') {
          elPromoAmount.addClass('currency--inr');
        } else {
          elPromoAmount.removeClass('currency--inr');
        }
      }
    });

    var currencyCode = Cookies.get('dc_pricing_currency');
    if ( currencyCode ) {
      $select.val(currencyCode)
      $select.trigger('change')

    } else {
      Cookies.set('dc_pricing_currency', $select.val());
    }
  }



  // Slider

  var seatsSlider = $('.js-seats-slider');
  var sliderMin = seatsSlider.attr('min');
  var sliderMax = seatsSlider.attr('max');
  var sliderInterval = sliderMax - sliderMin;
  // It doesn’t seem possible to get any property of the thumb.
  // The width is needed to compensate for how the browser calculates the thumb’s position.
  var thumbWidthPx = 52;

  function updateLabelPosition() {
    var value = seatsSlider.val();
    var sliderTrackWidth = $('.js-seats-slider-track').width();

    // Calculate the thumb’s position
    // Mirror the browser’s behaviour by taking into consideration the thumbs’ width
    var thumbWidthPct = thumbWidthPx * 100 / sliderTrackWidth;
    var valuePct = (value - sliderMin) * 100 / sliderInterval;
    valuePct -= thumbWidthPct * valuePct / 100;

    // Update the label’s position and the “progress” indicator width
    $('.js-seats-slider-label').css('left', valuePct + '%');
    $('.js-seats-slider-progress').css('width', valuePct + '%');
  }

  // Initialize the label’s position, so it doesn’t only rely on CSS
  updateLabelPosition();

  // IE11 does not support "oninput", only "onchange"
  // In the normal browsers, the actions are performed twice when the mouse is released
  // This does not affect the behaviour of the slider or the result
  seatsSlider.on('input change', function() {
    var value = $(this).val();
    var price = parseInt($('.subscription-price-yearly').text());

    $('.js-seats-slider-seats').text(value);
    $('.js-seats-slider-price').text((value * price).toLocaleString());
    updateLabelPosition();
  });

  $(window).resize(function() {
    updateLabelPosition();
  });

});
